'use strict';

const _ = require('underscore');
const ReadMore = require('framework/domain/value/readmore');

module.exports = class Page {
    constructor(min, prevCursor, prevMore, max, nextCursor, nextMore) {
        this._readMores = [];

        this._min = min;
        this._prevMore = prevMore;
        this._prevCursor = prevCursor;

        if(this._prevCursor && this._prevMore) {
            this._prevReadMore = new ReadMore({
                value: min,
                page: this,
                type: 'prev'
            });
            this._readMores.push(this._prevReadMore);
        }

        this._max = max;
        this._nextCursor = nextCursor;
        this._nextMore = nextMore;

        if(this._nextCursor && this._nextMore) {
            this._nextReadMore = new ReadMore({
                value: max,
                page: this,
                type: 'next'
            });
            this._readMores.push(this._nextReadMore);
        }
    }

    get min() {
        return this._min;
    }

    get prevCursor() {
        return this._prevCursor;
    }

    get prevMore() {
        return this._prevMore;
    }

    get max() {
        return this._max;
    }

    get nextCursor() {
        return this._nextCursor;
    }

    get nextMore() {
        return this._nextMore;
    }

    getReadMores() {
        return this._readMores;
    }

    include(num) {
        return this._min <= num && num <= this._max;
    }

    mergeNext(page) {
        this._max = this._max < page.max ? page.max : this._max;

        if(page.nextMore) {
            this._nextCursor = page.nextCursor;
            this._nextMore = page.nextMore;
            this._nextReadMore.set({value: this._max});
        } else {
            this._nextCursor = null;
            this._nextMore = page.nextMore;
            this._nextReadMore.destroy();
        }
    }

    mergePrev(page) {
        this._min = this._min < page.min ? page.min : this._min;

        if(page.prevCursor) {
            this._prevCursor = page.prevCursor;
            this._prevMore = page.prevMore;
            this._prevReadMore.set({value: this._min});
        } else {
            this._prevCursor = null;
            this._prevMore = page.prevMore;
            this._prevReadMore.destroy();
        }
    }
};



// WEBPACK FOOTER //
// ./framework/domain/value/page.js